// extracted by mini-css-extract-plugin
export default {"button":"Mp-z","reviewSort":"Np-z"};